import React from 'react';

interface IProps {
  className?: string;
  onClick?: () => void;
}

function DiscoverIcon(props: IProps): JSX.Element {
  return <div {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="24"
      fill="none"
      viewBox="0 0 36 24"
    >
      <path
        fill="#F9F9F9"
        d="M32.58 22.878H3.42a2.209 2.209 0 01-2.209-2.208V3.33c0-1.22.99-2.208 2.21-2.208H32.58c1.22 0 2.209.989 2.209 2.208v17.34c0 1.22-.99 2.208-2.21 2.208z"
      />
      <path
        fill="#FF6F00"
        d="M34.538 13.578l-.007.005-.04.025-.224.147-.006.004-.219.14a42.795 42.795 0 01-3.615 2.032c-2.857 1.445-5.814 2.649-8.845 3.677a76.812 76.812 0 01-7.073 2.036c-1.232.29-2.474.542-3.713.802-.18.037-.36.07-.54.103l-.018.006-1.945.44H32.59a2.2 2.2 0 002.2-2.199v-7.38l-.25.162z"
      />
      <path
        stroke="#303030"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.8"
        d="M32.58 22.878H3.42a2.209 2.209 0 01-2.209-2.208V3.33c0-1.22.99-2.208 2.21-2.208H32.58c1.22 0 2.209.989 2.209 2.208v17.34c0 1.22-.99 2.208-2.21 2.208z"
      />
      <path
        fill="#303030"
        d="M4.29 13.75V9.332c.017-.004.033-.012.049-.011.49.003.98-.016 1.468.017.782.053 1.437.37 1.834 1.074.783 1.386-.071 3.117-1.619 3.3-.389.047-.786.029-1.179.037-.18.004-.362.001-.553.001zm.87-.76c.163 0 .317.009.47 0 .341-.023.662-.104.928-.34.608-.54.643-1.565.074-2.152-.41-.423-.934-.432-1.473-.42v2.913zM28.8 9.329c.017-.004.026-.008.036-.008.49.003.98-.001 1.469.015.171.006.346.047.51.101.558.183.868.662.831 1.25-.021.334-.106.64-.358.88a1.28 1.28 0 01-.544.295l-.102.027c.462.619.92 1.23 1.39 1.861h-.584c-.13 0-.26-.004-.39.002-.071.003-.11-.024-.148-.081-.36-.542-.724-1.08-1.086-1.622-.036-.055-.07-.102-.16-.067v1.761H28.8V9.329zm.866 2.031c.271 0 .539.018.784-.118.225-.125.305-.33.303-.577-.003-.238-.093-.428-.311-.54-.245-.124-.51-.107-.776-.098v1.333zM25.785 9.325h2.434v.747h-1.567v.979h1.505v.754h-1.506v1.189h1.571v.747h-2.438V9.325zM12.423 9.746l-.45.587c-.165-.176-.34-.318-.578-.348-.237-.03-.46.008-.636.185-.19.19-.168.475.06.616.152.095.325.157.489.234.25.118.509.22.748.357.347.197.503.515.52.911.02.523-.138.966-.572 1.283-.328.239-.704.305-1.102.282-.605-.035-1.049-.336-1.37-.817l.52-.556c.108.124.194.25.305.347a.926.926 0 00.864.206.599.599 0 00.451-.704.503.503 0 00-.272-.355c-.161-.081-.332-.144-.499-.215-.18-.075-.363-.143-.537-.229-.558-.277-.729-.761-.57-1.364.133-.505.594-.858 1.164-.909a1.905 1.905 0 011.43.451c.01.009.019.02.035.038zM21.143 9.32c.302 0 .596-.002.89.004.027 0 .064.053.079.088.305.762.608 1.526.91 2.29l.233.58c.02-.047.036-.079.05-.111l1.109-2.763c.025-.062.052-.092.125-.09.277.005.554.002.848.002-.017.044-.029.078-.043.11-.61 1.448-1.22 2.896-1.827 4.344-.03.07-.064.093-.136.089-.1-.006-.2.004-.298-.005-.035-.002-.085-.03-.097-.06-.615-1.476-1.226-2.953-1.836-4.43-.004-.009-.003-.02-.007-.048zM16.268 10.496c-.139-.104-.258-.209-.391-.29-.515-.313-1.176-.24-1.64.173-.693.617-.66 1.82.064 2.378.543.418 1.3.397 1.818-.051l.15-.131v.158c0 .26-.002.52 0 .781.001.055-.016.085-.068.11-1.057.504-2.352.16-2.982-.813a2.314 2.314 0 011.486-3.537 2.183 2.183 0 011.489.186c.03.015.07.053.07.081.006.315.004.63.004.955z"
      />
      <path
        fill="#FF6F00"
        d="M21.291 11.538c.021 1.268-1.022 2.302-2.344 2.3-1.33-.002-2.353-.993-2.345-2.326.007-1.26 1.043-2.253 2.346-2.261 1.328-.008 2.364 1.036 2.343 2.287z"
      />
      <path fill="#303030" d="M9.19 13.745h-.854V9.328h.853v4.417z" />
    </svg>
  </div>
}

export default DiscoverIcon;
